module.exports = __webpack_public_path__ + "8810fdfd6560345f96f6d4997a740c63.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-white-s.png
// module id = 1803
// module chunks = 0